import LeadsTable from 'components/leads-table';

const AdminLeads = () => {
    return <LeadsTable />;
};

export default AdminLeads;
